import React from 'react';
import { Button } from '../ui/Button';
import { ShieldCheck, Lock } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-slate-900 text-white py-16 md:py-24 overflow-hidden" data-id="element-28">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#ffffff33_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-29"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-30">
        <div className="max-w-4xl mx-auto text-center mb-12" data-id="element-31">
          <div className="inline-flex items-center gap-2 bg-red-900/30 border border-red-500/30 rounded-full px-4 py-1.5 mb-6" data-id="element-32">
            <span className="flex h-2 w-2 rounded-full bg-red-500 animate-pulse" data-id="element-33"></span>
            <span className="text-red-200 text-xs md:text-sm font-semibold tracking-wide uppercase" data-id="element-34">
              Informe de Seguridad Urgente
            </span>
          </div>

          <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight leading-tight mb-6 text-white" data-id="element-35">
            Cómo evitar que tus hijos terminen en{' '}
            <span className="text-red-500 bg-red-900/20 px-2 rounded" data-id="element-36">
              Foster Care
            </span>{' '}
            si eres separado de ellos
          </h1>

          <p className="text-xl md:text-2xl text-slate-300 mb-8 font-medium max-w-2xl mx-auto" data-id="element-37">
            ¿Tienes ITIN? Tienes el derecho legal de blindar a tu familia hoy
            mismo. Sin abogados costosos.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12" data-id="element-38">
            <Button variant="primary" size="xl" className="w-full sm:w-auto shadow-red-500/20" onClick={() => {
            const el = document.getElementById('precio');
            if (el) {
              el.scrollIntoView({
                behavior: 'smooth'
              });
            }
          }} data-id="element-39">
              QUIERO PROTEGER A MI FAMILIA
            </Button>
            <p className="text-sm text-slate-400 mt-2 sm:mt-0" data-id="element-40">
              <Lock className="inline w-4 h-4 mr-1" data-id="element-41" /> Pago único de $6.39.
              Acceso inmediato.
            </p>
          </div>
        </div>

        {/* Product Image Showcase */}
        <div className="relative max-w-5xl mx-auto mt-8" data-id="element-42">
          <div className="absolute -inset-1 bg-gradient-to-r from-amber-500 to-red-600 rounded-2xl blur opacity-20" data-id="element-43"></div>
          <div className="relative bg-slate-800 rounded-xl border border-slate-700 p-4 md:p-8 shadow-2xl" data-id="element-44">
            <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-45">
              <div className="order-2 md:order-1" data-id="element-46">
                <img src="https://cdn.magicpatterns.com/uploads/bEAsB9KBqc99JVjaj8k6io/heylloyd-image-1771906723527.png" alt="El Protocolo Sombrilla en Tablet" className="w-full h-auto rounded-lg shadow-lg transform md:scale-110 md:translate-x-4 transition-transform duration-700 hover:scale-105" data-id="element-47" />
              </div>
              <div className="order-1 md:order-2 space-y-6" data-id="element-48">
                <div className="flex items-start gap-4" data-id="element-49">
                  <div className="bg-amber-500/10 p-3 rounded-lg" data-id="element-50">
                    <ShieldCheck className="w-8 h-8 text-amber-500" data-id="element-51" />
                  </div>
                  <div data-id="element-52">
                    <h3 className="text-lg font-bold text-white" data-id="element-53">
                      Protección Legal Inmediata
                    </h3>
                    <p className="text-slate-400" data-id="element-54">
                      Documentos listos para firmar que protegen a tus hijos.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-55">
                  <div className="bg-amber-500/10 p-3 rounded-lg" data-id="element-56">
                    <Lock className="w-8 h-8 text-amber-500" data-id="element-57" />
                  </div>
                  <div data-id="element-58">
                    <h3 className="text-lg font-bold text-white" data-id="element-59">
                      Blindaje Financiero
                    </h3>
                    <p className="text-slate-400" data-id="element-60">
                      Asegura que tus ahorros no queden congelados.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}